import { connect } from 'react-redux';
import { filterSetFilters } from 'redux/saga/selectors';
import { selectIsMobile } from 'redux/modules/device';
import { SEARCH } from 'constants/filter-sets';
import { decorateWith, withName } from 'helpers/decorator';
import { deepExtract } from 'helpers/deep';
import { FilterGroup } from '../components/filters/FilterGroup';
import { searchFilterActions } from './filters.helpers';
import { filtersChanged } from './filters.saga';

const { clearMultipleFilters, setMultipleFiltersEditing } = searchFilterActions;

export const mapStateToProps = (state, ownProps) => {
  const { filterOptionContainers } = ownProps;

  const filterNames = filterOptionContainers.map(optionContainer => optionContainer.name);
  const filters = filterSetFilters(state, SEARCH);
  const isOutOfSync = filterNames.some(filterName => deepExtract(`${filterName}.needsUpdate`, filters, false));
  const isSelected = filterNames.some(filterName => deepExtract(`${filterName}.filtered`, filters, false));
  const isEditing = filterNames.some(filterName => deepExtract(`${filterName}.isEditing`, filters, false));
  const isMobile = selectIsMobile(state);

  return {
    isOutOfSync,
    isSelected,
    isMobile,
    isEditing,
  };
};

const mapDispatchToProps = {
  onSyncFilters: filtersChanged,
  onClear: clearMultipleFilters,
  onSetIsEditing: (filterNames, isEditing) => setMultipleFiltersEditing(filterNames, isEditing),
};

export const FilterGroupContainer = decorateWith(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withName('FilterGroupContainer')
)(FilterGroup);
